import { Button } from '@/shared/ui/button';
import { assistantToolbarClasses } from '@/modules/assistant/parts/styles';

export type PanelToolbarProps = {
  /** Whether the conversation history is showing. */
  historyOpen: boolean;
  /** Shows or hides the conversation history. */
  onToggleHistory: () => void;
  /** Whether a new conversation can be started. */
  canStartNew: boolean;
  /** Closes the open conversation. */
  onNewConversation: () => void;
};

/**
 * The row above the conversation.
 *
 * "Conversations" opens the history the server holds; "New conversation" puts
 * the person back on a blank conversation. The second is disabled when there is
 * no conversation open, because a disabled control that is always disabled is
 * noise — and this one is only ever disabled in exactly that state.
 */
export function PanelToolbar({
  historyOpen,
  onToggleHistory,
  canStartNew,
  onNewConversation,
}: PanelToolbarProps) {
  return (
    <div className={assistantToolbarClasses}>
      <Button size="sm" variant="ghost" aria-expanded={historyOpen} onClick={onToggleHistory}>
        Conversations
      </Button>
      <Button size="sm" variant="ghost" disabled={!canStartNew} onClick={onNewConversation}>
        New conversation
      </Button>
    </div>
  );
}
